import Groups from "@/src/screens/groups/groups";

export default function GroupsScreen() {
	return <Groups />;
}
